import styled from "@emotion/styled"
import Title from "components/Title"

const TechThreeTitle = styled(Title)`
  font-family: ${({ theme }) => theme.typography.fontFamilyGilroy};
  margin-block-start: 0;
  margin-block-end: 0;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    font-size: 36px;
    margin-bottom: 32px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    font-size: 45px;
    margin-bottom: 52px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    font-size: 60px;
    margin-bottom: 52px;
  }
`

export default TechThreeTitle
